import { lazy } from 'react';

import { lazyNamed } from 'src/utils/lazyNamed.ts';
import { PartnerFilialManagement } from './containers/PartnerFilialManagement/index.tsx';
import { ReferencePerAdmedia } from './containers/ReferencePerAdmedia/index.tsx';

export default {
  Helmet: lazy(() => import('./components/Helmet.tsx')),
  DataImport: lazy(() => import('./containers/DataImport/index.tsx')),

  PartnerFilialManagement,
  ReferencePerAdmedia,
  SpecialDiscounts: lazyNamed(() => import('./containers/SpecialDiscounts/index.tsx'), 'SpecialDiscounts'),
  Contracts: {
    ContractsList: lazyNamed(() => import('./containers/Contracts/containers/ContractsList/index.tsx'), 'ContractsList'),
    ContractForm: lazyNamed(() => import('./containers/Contracts/containers/ContractForm/index.tsx'), 'ContractForm'),
    ContractHistory: lazyNamed(() => import('./containers/Contracts/containers/ContractHistory/index.tsx'), 'ContractHistory'),
    ContractProgress: lazyNamed(() => import('./containers/Contracts/containers/ContractProgress/index.tsx'), 'ContractProgress'),
    ContractSettlementsList: lazyNamed(
      () => import('./containers/Contracts/containers/ContractSettlementsList/index.tsx'),
      'ContractSettlementsList',
    ),
    ContractSettlements: lazyNamed(() => import('./containers/Contracts/containers/ContractSettlements/index.tsx'), 'ContractSettlements'),
  },
};
